import { connect } from "vuex-connect";
// import log from 'loglevel';
import { ComicEditor } from "../../../components";

export default connect({
  stateToProps: {
    images: state => state.uploadContents.images,
    draftId: state => state.uploadContents.draftId,
    pageProgressionDirection: state =>
      state.uploadContents.pageProgressionDirection,
    isSetFrontCover: state => state.uploadContents.isSetFrontCover,
    userFrontCoverImageUrl: state =>
      state.uploadContents.userFrontCoverImageUrl,
    userBackCoverImageUrl: state => state.uploadContents.userBackCoverImageUrl,
    isBusy: state => state.common.isBusy,
    frontCoverType: state => state.uploadContents.frontCoverType,
    backCoverType: state => state.uploadContents.backCoverType,
    frontCoverNextData: state => state.uploadContents.frontCoverNextData,
    backCoverPrevData: state => state.uploadContents.backCoverPrevData,
    isSetFrontCoverNext: state => state.uploadContents.isSetFrontCoverNext,
    isSetBackCoverPrev: state => state.uploadContents.isSetBackCoverPrev
  },
  gettersToProps: {
    getNotIncludeCoverDataImageCount:
      "uploadContents/getNotIncludeCoverDataImageCount"
  },
  actionsToProps: {
    deleteDraftImage: (dispatch, value) => {
      return dispatch("uploadContents/deleteDraftImage", value);
    },
    sortImages: (dispatch, value) => {
      return dispatch("uploadContents/sortImages", value);
    },
    postFrontCoverImage: (dispatch, value) =>
      dispatch("uploadContents/postFrontCoverImage", value),
    postBackCoverImage: (dispatch, value) =>
      dispatch("uploadContents/postBackCoverImage", value),
    postDraftStaticImage: (dispatch, value) =>
      dispatch("uploadContents/postDraftStaticImage", value),
    deleteStaticImageData: dispatch =>
      dispatch("uploadContents/deleteStaticImageData"),
    setInitialStaticImageData: dispatch =>
      dispatch("uploadContents/setInitialStaticImageData"),
    putBlankArea: dispatch => dispatch("uploadContents/putBlankArea"),
    deleteBlankArea: dispatch => dispatch("uploadContents/deleteBlankArea"),
    putBlankStaticCoverBack: (dispatch, value) =>
      dispatch("uploadContents/putBlankStaticCoverBack", value)
  },
  mutationsToProps: {
    setIsBusy: "uploadContents/setIsImageBusy",
    updateUserFrontCoverImageUrl: (commit, value) =>
      commit("uploadContents/updateUserFrontCoverImageUrl", value),
    updateUserBackCoverImageUrl: (commit, value) =>
      commit("uploadContents/updateUserBackCoverImageUrl", value),
    updateFrontCoverType: (commit, value) =>
      commit("uploadContents/updateFrontCoverType", value),
    updateBackCoverType: (commit, value) =>
      commit("uploadContents/updateBackCoverType", value),
    refreshImages: commit => commit("uploadContents/refreshImages"),
    updateIsSetFrontCoverNext: (commit, value) =>
      commit("uploadContents/updateIsSetFrontCoverNext", value),
    updateIsSetBackCoverPrev: (commit, value) =>
      commit("uploadContents/updateIsSetBackCoverPrev", value),
    updateFrontCoverNextData: (commit, value) =>
      commit("uploadContents/updateFrontCoverNextData", value),
    updateBackCoverPrevData: (commit, value) =>
      commit("uploadContents/updateBackCoverPrevData", value),
    updateCoverProcess: "uploadContents/updateCoverProcess",
    updatePageProgressionDirection: (commit, value) =>
      commit("uploadContents/updatePageProgressionDirection", value),
    setIsBusyNormal: (commit, value) =>
      commit("common/setIsBusy", value, { root: true })
  }
})(ComicEditor.name, ComicEditor);
